export const superScriptMapping: Record<string, string> = {
	'0': '&#x2070;',
	'1': '&#x00B9;',
	'2': '&#x00B2;',
	'3': '&#x00B3;',
	'4': '&#x2074;',
	'5': '&#x2075;',
	'6': '&#x2076;',
	'7': '&#x2077;',
	'8': '&#x2078;',
	'9': '&#x2079;',
}
